module.exports = __webpack_public_path__ + "static/img/5-4.36e9ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/5-4.png
// module id = cqQh
// module chunks = 1